export const state = () => ({
  rankingFactors: null,
  all_analyzed_details: [],
  analyses_details: null
})

export const getters = {}

export const mutations = {
  UPDATE_RANKING_FACTORS (state, rankingFactors) {
    state.rankingFactors = rankingFactors
  },

  CREATE_ANALYSES_DETAILS (state, analysesDetails) {
    state.analyses_details = analysesDetails
    state.all_analyzed_details = analysesDetails
  },

  UPDATE_ANALYSES_DETAILS (state, analysesDetails) {
    state.analyses_details = analysesDetails
    state.analyses_details.push()
  }
}

export const actions = {
  CreateAnalysesDetails ({ commit, rootState }) {
    commit('CREATE_ANALYSES_DETAILS', rootState.analysis.all_analyzed_details)
  },

  GetRankingFactors ({ commit }, { data }) {
    return new Promise((resolve, reject) => {
      this.$axios.get('/api/dashboard/' + data.analysisId + '/google_algorithm_changes', {
        params: {
          ...data.params
        }
      })
        .then((response) => {
          commit('UPDATE_RANKING_FACTORS', response.data.result)
          resolve()
        })
        .catch((e) => {
          if (e.response.status === 400) {
            commit('UPDATE_RANKING_FACTORS', [])

            this._vm.$message({
              type: 'error',
              duration: 5000,
              message: e.response.data.error,
              showClose: true
            })

            resolve()
          } else {
            reject(e.response.data.error)
          }
        })
    })
  }
}

export const modules = {}
